import reactPrefixer from 'react-prefixer'

export default function prefix (style, options = {}) {
  if (typeof style === 'function') {
    return function (...args) {
      return reactPrefixer(style(...args))
    }
  }

  return reactPrefixer(style)
}
